import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Room = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3 19.8h3m0 0 9 1.2V3L6 4.8z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 6h3.6v13.8H21'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 12v1.2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 3a.75.75 0 0 0-.897-.735l-9 1.8a.75.75 0 0 0-.603.735v14.25H3a.75.75 0 0 0 0 1.5h2.95l8.95 1.193a.75.75 0 0 0 .85-.743V6.75h2.1V19.8c0 .414.336.75.75.75H21a.75.75 0 0 0 0-1.5h-1.65V6a.75.75 0 0 0-.75-.75h-2.85zM12 11.25a.75.75 0 0 1 .75.75v1.2a.75.75 0 0 1-1.5 0V12a.75.75 0 0 1 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
